import { PickerMode } from "@shared/common/types/main";
import DateType from "@shared/enums/DateType";
import { InsightUsage } from "@shared/models/dashboard";
import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(isoWeek);
dayjs.extend(quarterOfYear);

export const formatDate = (
  date: Date | string,
  options?: Intl.DateTimeFormatOptions,
  dateFormat?: 'YYYY-MM-DD',
): string => {
  const hasTimezone = (dateStr: string) => {
    return /Z|[+-]\d{2}:?\d{2}$/.test(dateStr);
  };
  var nd = new Date(date);
  if (!hasTimezone(date.toString())) {
    const utc = nd.getTime() + -nd.getTimezoneOffset() * 60000;
    nd = new Date(utc);
  }

  if (dateFormat) {
    const year = nd.getFullYear();
    const month = String(nd.getMonth() + 1).padStart(2, '0');
    const day = String(nd.getDate()).padStart(2, '0');

    switch (dateFormat) {
      case 'YYYY-MM-DD':
        return `${year}-${month}-${day}`;
    }
  }

  return nd.toLocaleString(undefined, options);
};

export const getBahaviouralLabelName = (item: InsightUsage, type: DateType): string => {
  if(type === DateType.DAY) {
    return `${String(item.day).padStart(2, '0')} ${dayjs().month(item.month - 1).format("MMMM")}`;
  }
  return `${dayjs().month(item.month - 1).format("MMMM")} ${item.year}`;
}

export const normalizeRange = (
  mode: PickerMode,
  range: [Dayjs | null, Dayjs | null] | null
): [Dayjs | null, Dayjs | null] | null => {
  if (!range) return null;
  const [start, end] = range;
  if (!start || !end) return [start, end];

  switch (mode) {
    case "week":
      // ISO week (Mon-Sun). Jeśli chcesz Sun-Sat użyj startOf("week")/endOf("week")
      return [start.startOf("isoWeek"), end.endOf("isoWeek")];

    case "month":
      return [start.startOf("month"), end.endOf("month")];

    case "quarter":
      return [start.startOf("quarter"), end.endOf("quarter")];

    case "year":
      return [start.startOf("year"), end.endOf("year")];

    case "date":
    default:
      // bez zmian (albo możesz też wymuszać startOf("day")/endOf("day"))
      return [start.startOf("day"), end.endOf("day")];
  }
}
